import { createTheme } from '@mui/material/styles';
import { palette } from './palette';
import { breakpoints } from './breakpoints';
import { typography } from './typography';

export const theme = createTheme({
  direction: 'rtl',
  breakpoints,
  palette: {
    primary: {
      main: palette.primary,
    },
    secondary: {
      main: palette.secondary,
    },
    background: {
      default: palette.backgroundPrimary,
      paper: palette.white,
    },
    text: {
      primary: palette.primary,
    },
    divider: palette.border,
  },
  typography,
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          direction: 'rtl',
          backgroundColor: palette.backgroundPrimary,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '80px',
          textTransform: 'none',
          minWidth: 'auto',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
        endIcon: {
          margin: 0,
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          borderRadius: '80px',
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          left: 'auto',
          right: 0,
          transformOrigin: 'right top',
        },
        outlined: {
          transform: 'translate(-14px, 16px) scale(1)',
          '&.MuiInputLabel-shrink': {
            transform: 'translate(-14px, -9px) scale(0.75)',
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: '12px',
        },
        notchedOutline: {
          textAlign: 'right',
          borderColor: palette.border,
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        icon: {
          right: 'auto',
          left: 7,
        },
        select: {
          paddingRight: '14px !important',
          paddingLeft: '32px',
        },
      },
    },
  },
});

export { palette } from './palette';
